import React from 'react';
import deepEqual from 'lodash/isEqual';

/**
 * https://github.com/kentcdodds/use-deep-compare-effect
 */
function checkDeps(deps?: React.DependencyList) {
	if (!deps || !deps.length) {
		throw new Error('useDeepCompareEffect should not be used with no dependencies. Use React.useEffect instead.');
	}
	if (deps.every(isPrimitive)) {
		throw new Error(
			'useDeepCompareEffect should not be used with dependencies that are all primitive values. Use React.useEffect instead.'
		);
	}
}

function isPrimitive(val?: any) {
	if (val === undefined) return false;
	return val == null || /^[sbn]/.test(typeof val);
}

function useDeepCompareMemoize(value?: React.DependencyList): React.DependencyList {
	const ref = React.useRef<any>(undefined);

	if (!deepEqual(value, ref.current)) {
		ref.current = value;
	}

	return ref.current;
}

function useDeepCompareEffect(callback: React.EffectCallback, dependencies?: React.DependencyList) {
	if (import.meta.env.DEV) {
		checkDeps(dependencies);
	}
	// eslint-disable-next-line
	React.useEffect(callback, useDeepCompareMemoize(dependencies));
}

export function useDeepCompareEffectNoCheck(callback: React.EffectCallback, dependencies?: React.DependencyList) {
	// eslint-disable-next-line
	React.useEffect(callback, useDeepCompareMemoize(dependencies));
}

export default useDeepCompareEffect;
